/**
 * Session timing from Vite env — no business durations hardcoded in call sites.
 * Values are set in trend_voyage_fe/.env (and mirrored in backend/.env).
 */

const parsePositiveInt = (value) => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : null
}

export const SESSION_INACTIVITY_MS = parsePositiveInt(
  import.meta.env.VITE_SESSION_INACTIVITY_MS
)

export const TOKEN_REFRESH_LEEWAY_SECONDS = parsePositiveInt(
  import.meta.env.VITE_TOKEN_REFRESH_LEEWAY_SECONDS
)

export const TOKEN_REFRESH_POLL_MS = parsePositiveInt(
  import.meta.env.VITE_TOKEN_REFRESH_POLL_MS
)
